import axios from "axios";


const BASE_URL ="http://localhost:3000/";

export const refreshAccessToken = async (currentRefreshToken) => {
  try {
    const response = await axios.post(`${BASE_URL}api/refresh/`, {
      refresh: currentRefreshToken,
    });

    if (response.status === 200) {
      return response.data; // should contain { access_token, refresh_token }
    }
    return null;
  } catch (error) {
    console.error("Error refreshing token", error);
    return null;
  }
};
